export class Oauth {
    companyId: string;
    parameters: string;
    environment: string;
    integrationClass: string;
}
